import ListEditor from './ListEditor'
import { useState, useMemo, useReducer } from 'react'
import { MainAppMethods } from '../../App'
/*import './AddressBan.css'*/
import PagerTable from '../../common/tables/PagerTable'


export default function CallDispositionTypes(props: MainAppMethods) {


    const [selectedList, setSelectedList] = useState<any>(null) // selected ban address list
    const [tableData, setTableData] = useState<any>({
        count: 0,
        data: [],
    }) // current data (list of lists) for table. 
    const [refresh, doRefresh] = useReducer((d) => d + 1, 0);


    // FIXME... OLX still stuck on FA V4... need to update to at least 5
    let faIconClass = sessionStorage.getItem("pencilimg") ?? ""

    const onListSaved = (list?: any) => {
        // trigger a refresh of the list by updating the refresh #   
        doRefresh();
        // if list was provided...we want to keep it open. User is continuing to edit without closing
        if (list) setSelectedList(list);
        else setSelectedList(null);
    }


    const createNewCallDispositionType = () => {
        // create a new CallDispositionType object for editor.
        const l = {
            callDispositionTypeId: "0",
            name: "",
            sortOrder: "0",
            createdDttm: "" ,
            createdBy: "",
            ModifiedDttm: "",
            Modifiedby:""
        }
        setSelectedList(l);
    }

    const columns = useMemo(
        () => [
            {
                Header: <i className='fa fa-solid fa-plus' onClick={() => createNewCallDispositionType()} />,
                accessor: 'editbtn', // accessor is the "key" in the data
                maxWidth: 30
            },
            {
                Header: 'Name',
                accessor: 'name',
                minWidth: 300
            },
            {
                Header: 'Client',
                accessor: 'client',
                minWidth: 300
            },
            {
                Header: 'Display Order ',
                accessor: 'sortOrder',
                minWidth: 300
            },
            {
                Header: 'Modified Date',
                accessor: "modifiedDttm"
            },
            {
                Header: '# Dispositions',
                accessor: "count"
            }
        ],
        []
    )


    const getData = (pageSize: number, pageIndex: number) => {
        const apiBase = sessionStorage.getItem("apibase");
        var _url = `${apiBase}/v1/CallDispositionType?page=${pageIndex}&pageSize=${pageSize}`;
        console.log("Preparing to call api:" + _url);

        fetch(_url,
            {
                method: "GET",
                headers: props.getHeaders(),
            })
            .then(response => response.json())
            .then((resp: any) => {
                // first column will container button
                resp.data.map((d: any) => {
                    d.editbtn = <i className={faIconClass} onClick={() => setSelectedList(d)} />
                    d.modifiedDttm = d.modifiedDttm? new Date(d.modifiedDttm).toLocaleString():''
                });
                setTableData(resp);
            });

    }

    return (
        <div>
            <PagerTable getData={getData} columns={columns} tableData={tableData} refresh={refresh} />
            {
                selectedList ? <ListEditor onListSaved={onListSaved} list={selectedList} getHeaders={props.getHeaders} /> : null
            }

        </div>

    )


}